import styled from 'styled-components'
import { orange } from '@/theme/colors'

export const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 8px 0;
`

export const DateInputGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const DateLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #374151;
`

export const DateInput = styled.div`
	width: 100%;

	/* Style the MUI DatePicker input to have white background */
	.MuiFormControl-root {
		background-color: white;
		border-radius: 6px;
	}

	.MuiPickersInputBase-root {
		background-color: white;
	}
`

export const ErrorMessage = styled.div`
	color: #ef4444;
	font-size: 14px;
	padding: 8px 12px;
	background-color: #fee2e2;
	border-radius: 6px;
	border: 1px solid #fecaca;
`

export const UnsavedChangesText = styled.div`
	color: ${orange};
	font-size: 14px;
	font-weight: 500;
	text-align: center;
`

export const ButtonGroup = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 8px;
`

export const CancelButton = styled.button`
	flex: 1;
	padding: 10px 16px;
	background-color: white;
	color: #374151;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		background-color: #f3f4f6;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const SaveButton = styled.button`
	flex: 1;
	padding: 10px 16px;
	background-color: ${orange};
	color: white;
	border: none;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

